module.exports = __webpack_public_path__ + "static/media/logout_icon.81d4385c.svg";